export enum BuyerContactsActionTypes {
  SET_BUYER_CONTACTS = 'SET_BUYER_CONTACTS',
}

export interface Contact {
  email: string
  firstName: string
  lastName: string
  title: string
  createdAt: string
  associatedOffers: string[]
}

export interface Contacts {
  contacts: Contact[]
}

export const initialBuyerContactsState: Contacts = { contacts: [] }

export type BuyerContactsAction = {
  type: BuyerContactsActionTypes.SET_BUYER_CONTACTS
  payload: Contacts
}
